import { Link } from "react-router-dom";
import ArrowRightIcon from "../../../icons/arrowRightIcon";
import { useTranslation } from "react-i18next";

const ServicesCard = ({ Icon, header, text, link }) => {
  const { t } = useTranslation();
  return (
    <div className="md:w-[30%] bg-white shadow-mainShadow rounded-2xl p-8 space-y-4">
      <h2 className="flex items-center gap-2 text-xl font-bold ">
        {Icon} {header}
      </h2>
      <p className="text-mainGray">{text}</p>
      <Link
        className="px-3  py-3 bg-mainRed rounded-lg text-white flex items-center gap-2 font-bold w-[150px] text-base justify-center arrow-link"
        to={link}
      >
        <span>{t("seeMore")}</span>
        <span className="rtl:rotate-180 arrow">
          <ArrowRightIcon fill={"white"} />
        </span>
      </Link>
    </div>
  );
};

export default ServicesCard;
